import { ArrowRight } from "lucide-react";
import type { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/layout/ThemeToggle";

function BrandMark({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-primary to-brand text-primary-foreground shadow-sm",
        className,
      )}
      aria-hidden
    >
      <span className="font-display text-[0.95rem] font-semibold tracking-tight">
        33
      </span>
    </div>
  );
}

function HeaderRoute({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link
      to={to}
      className="rounded-full px-3 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
    >
      {children}
    </Link>
  );
}

export function SiteHeader() {
  const location = useLocation();
  const isSite =
    location.pathname.startsWith("/numeroloji") ||
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/wordpress-baglanti") ||
    location.pathname.startsWith("/pdf-onizleme");

  const isKarma = !isSite;

  return (
    <header className="sticky top-0 z-50 border-b bg-background/70 backdrop-blur supports-[backdrop-filter]:bg-background/55">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <div className="flex items-center gap-3">
          <Link to="/" className="inline-flex items-center gap-3">
            <BrandMark />
            <div className="leading-tight">
              <div className="font-display text-sm font-semibold tracking-tight sm:text-base">
                Circle
              </div>
              <div className="text-xs text-muted-foreground">
                Numeroloji • Koç Modu • Çember
              </div>
            </div>
          </Link>
        </div>

        <nav className="hidden items-center gap-1 sm:flex">
          {isKarma ? (
            <>
              <HeaderRoute to="/likes">Beğeniler</HeaderRoute>
              <HeaderRoute to="/">Keşif</HeaderRoute>
              <HeaderRoute to="/messages">Mesajlar</HeaderRoute>
              <HeaderRoute to="/profile">Profil</HeaderRoute>
              <HeaderRoute to="/numeroloji">Numeroloji</HeaderRoute>
            </>
          ) : (
            <>
              <HeaderRoute to="/numeroloji">Numeroloji</HeaderRoute>
              <HeaderRoute to="/numeroloji#paketler">Paketler</HeaderRoute>
              <HeaderRoute to="/admin/numeroloji">Yönetim</HeaderRoute>
              <HeaderRoute to="/">Karma</HeaderRoute>
            </>
          )}
        </nav>

        <div className="flex items-center gap-2">
          <ThemeToggle />

          <Button asChild className="hidden rounded-full sm:inline-flex">
            <Link to={isKarma ? "/karma/me" : "/numeroloji/magaza"}>
              {isKarma ? (
                <>
                  Panel <ArrowRight className="h-4 w-4" />
                </>
              ) : (
                <>
                  Satın al <ArrowRight className="h-4 w-4" />
                </>
              )}
            </Link>
          </Button>
        </div>
      </div>
    </header>
  );
}
